import { useContext, useEffect, useState } from "react";
import Cuadricula from "../../assets/svg/Cuadricula.svg";
import Lista from "../../assets/svg/Lista.svg";
import { createCoursesModal } from "../../context/FormacionDesarollo/FormacionDesarrolloActions";
import CheckPermission from "../../helpers/Administradores/Permissions";
import FormacionDesarolloContext from "../../context/FormacionDesarollo/FormacionDesarrolloContext";
import AddIcon from "../../assets/svg/icono_agregar_blue.svg";
import "./css/FormacionDesarrollo.css";
import CreateCourse from "./modals/CreateCourse";
import UpdateCourse from "./modals/UpdateCourse";
import { Grid } from "@material-ui/core";
import BodyCourses from "./BodyCourses";

const Courses = () => {
  const { state, dispatch } = useContext(FormacionDesarolloContext);
  const [viewList, setViewList] = useState(false);
  const [viewSquare, setViewSquare] = useState(true);
  const [infoImg, setInfoImg] = useState({});

  const handleViewSquare = () => {
    setViewSquare(true);
    setViewList(false);
    localStorage.setItem("view", String("square"));
  };

  const handleViewList = () => {
    setViewSquare(false);
    setViewList(true);
    localStorage.setItem("view", String("list"));
  };

  // Agregué [] para que solo se ejecute una vez al montar el componente
  useEffect(() => {
    let view = localStorage.getItem("view");
    if (view === "square") {
      handleViewSquare();
    } else if (view === "list") {
      handleViewList();
    } else {
      handleViewSquare();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); 

  return (
    <>
      <div className="conteinerBtnsCourses">
        
        {/* Botón Cuadrícula */}
        <div 
            className={`btnViewMode ${viewSquare ? 'active' : ''}`} 
            onClick={() => handleViewSquare()}
        >
          <img src={Cuadricula} alt="Cuadricula" />
          <span>Cuadrícula</span>
        </div>

        {/* Botón Lista */}
        <div 
            className={`btnViewMode ${viewList ? 'active' : ''}`} 
            onClick={() => handleViewList()}
        >
          <img src={Lista} alt="Lista" />
          <span>Lista</span>
        </div>

        {CheckPermission("FormacionDesarrollo.Cursos.NuevoCurso") && (
          <div>
            <button
              id="addCourse"
              onClick={() => createCoursesModal('0', true, dispatch)}
              className="btnNuevoCurso"
            >
              <div className="alineacionBoton">
                <img src={AddIcon} alt="Agregar Curso" />
                <div className="nombreCurso">
                  <b>
                    <span>Nuevo curso</span>
                  </b>
                </div>
              </div>
            </button>
          </div>
        )}
      </div>

      <CreateCourse setInfoImg={setInfoImg} />
      {state._id !== '' &&
        <UpdateCourse setInfoImg={setInfoImg} />
      }
      <Grid className="containerBodyCursos">
        <BodyCourses
          infoImg={infoImg}
          viewSquare={viewSquare}
          viewList={viewList}
        />
      </Grid>
    </>
  );
};

export default Courses;